$(document).ready(function () {

    var mapboxgl = require('mapbox-gl/dist/mapbox-gl.js');


    if ($('#mapid').length) {

        mapboxgl.accessToken = 'pk.eyJ1IjoiZ3VpbGxhdW1lb3MiLCJhIjoiY2s5dTEzdHJhMWpxdjNscnRmMmk4NmxpaSJ9.7YC25AN2RIi_IpUIEr6Glg';
        var map = new mapboxgl.Map({
            container: 'mapid',
            style: 'mapbox://styles/mapbox/dark-v10',
            center: [6.122366240543897, 45.905231916991056], // starting position [lng, lat]
            zoom: 15 // starting zoom
        });
        map.scrollZoom.disable();

        map.on("load", function () {
            /* Image: An image is loaded and added to the map. */
            map.loadImage("images/marker.webp", function (error, image) {
                if (error) throw error;
                map.addImage("custom-marker", image);
                /* Style layer: A style layer ties together the source and image and specifies how they are displayed on the map. */
                map.addLayer({
                    id: "markers",
                    type: "symbol",
                    /* Source: A data source specifies the geographic coordinate where the image marker gets placed. */
                    source: {
                        type: "geojson",
                        data: {
                            type: 'FeatureCollection',
                            features: [
                                {
                                    type: 'Feature',
                                    properties: {},
                                    geometry: {
                                        type: "Point",
                                        coordinates: [6.1224, 45.9052]
                                    }
                                }
                            ]
                        }
                    },
                    layout: {
                        "icon-image": "custom-marker",
                    }
                });
            });
        });
    }
});
